import FP2 from 'fingerprintjs2'

export default new Promise(resolve => {
  new FP2().get(resolve)
})


// WEBPACK FOOTER //
// ./src/lib/fp.js